let vars = {
    currentView: null,		    // Current view obj
    calendarElement: null,      // Ref to element that holds shadow dom
    calendarShadowDom: null,	// Shadow dom ref
    viewContainer: null,		// Element to switch in and out views
    pubcalendar: null,          // Cache of pubcalendar endpoint. Cached here instead of using api cache to avoid multiple calls on calendar init
    version: appVersion,        // current version of the widget from package.json
    buildDate: buildDate,       // build date from webpack
}

export {
    vars
};